// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `bai-course-action-button .spinner {
  margin: 0px !important;
  height: 20px !important;
  text-align: left !important;
  float: right;
}

bai-course-action-button .course-title-link {
  font-size: 12px;
}

assignment-action-button .spinner {
  margin: 0px !important;
  height: 20px !important;
  width: auto !important;
  text-align: left !important;
  float: right;
}

assignment-action-button .course-title-link {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/courseActionButtons.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":["bai-course-action-button .spinner {\n  margin: 0px !important;\n  height: 20px !important;\n  text-align: left !important;\n  float: right;\n}\n\nbai-course-action-button .course-title-link {\n  font-size: 12px;\n}\n\nassignment-action-button .spinner {\n  margin: 0px !important;\n  height: 20px !important;\n  width: auto !important;\n  text-align: left !important;\n  float: right;\n}\n\nassignment-action-button .course-title-link {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
